module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid22_1080x852.db4a3b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid22_1080x852.jpg
// module id = LpK2
// module chunks = 0